import { bootstrapApplication } from '@angular/platform-browser';
import {
  RouteReuseStrategy,
  provideRouter,
  withPreloading,
  PreloadAllModules,
} from '@angular/router';
import {
  IonicRouteStrategy,
  provideIonicAngular,
} from '@ionic/angular/standalone';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { AppComponent } from './app/app.component';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app/app.routes';

import { provideApollo } from 'apollo-angular';
import { inject, Injector } from '@angular/core';
import { HttpLink } from 'apollo-angular/http';
import { environment } from '@infra-env/environment';
import { ApolloLink, InMemoryCache } from '@apollo/client/core';
import { createGraphQLErrorLink } from '@infra-adapters/interceptors/authError.interceptor';
import { createAuthLink } from '@infra-adapters/interceptors/authLink';
import { registerLocaleData } from '@angular/common';
import localeEsCL from '@angular/common/locales/es-CL';
import { addIcons } from 'ionicons';
import { 
  notificationsOutline, 
  giftOutline, 
  pricetagOutline, 
  calendarOutline,
  chevronDown 
} from 'ionicons/icons';

registerLocaleData(localeEsCL, 'es-CL');

addIcons({
  'notifications-outline': notificationsOutline,
  'gift-outline': giftOutline,
  'pricetag-outline': pricetagOutline,
  'calendar-outline': calendarOutline,
  'chevron-down': chevronDown,
});

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular({
      // scrollAssist/scrollPadding desactivados: Ionic mueve el ion-content
      // al aparecer el teclado y compite con el handler Keyboard de Capacitor
      // configurado en AppComponent + capacitor.config.ts (resize: 'ionic').
      // En iOS esto producía doble reflow y dejaba el scroller en estado
      // inconsistente tras la primera interacción con un input.
      scrollAssist: false,
      scrollPadding: false,
      // Defaults conservados: mode autodetect (iOS look en iPhone, MD en Android),
      // swipeBackEnabled: true (gesture nativo iOS), hardwareBackButton: true.
    }),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([])),
    provideApollo(() => {
      const httpLink = inject(HttpLink);
      const injector = inject(Injector);
      const authLink = createAuthLink(injector);

      const errorLink = createGraphQLErrorLink(injector);

      return {
        link: ApolloLink.from([
          errorLink,
          authLink,
          httpLink.create({ uri: environment.apiUrl }),
        ]),
        cache: new InMemoryCache({
          addTypename: false,
        }),
      };
    }),
  ],
}).catch(err => {
  console.error('[Bootstrap] FATAL ERROR:', JSON.stringify(err, Object.getOwnPropertyNames(err)));
  console.error('[Bootstrap] Stack:', err?.stack);
  document.body.innerHTML = `<pre style="color:red;padding:20px">[Bootstrap Error]\n${err?.message}\n\n${err?.stack}</pre>`;
});
